import React from 'react'

/**
 * Sortable table header cell - matches TableGrid pattern (datatable-sorter, datatable-ascending/descending).
 */
const SortableTh = ({ label, sortKey, currentSortColumn, sortDirection, onSort, sortable = true }) => {
  if (!sortable) {
    return <th>{label}</th>
  }
  const isActive = currentSortColumn === sortKey
  const sortClass = isActive
    ? (sortDirection === 'asc' ? 'datatable-ascending' : 'datatable-descending')
    : ''
  return (
    <th
      className={sortClass}
      style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap', verticalAlign: 'middle' }}
      onClick={() => onSort && onSort(sortKey)}
      title="Click to sort"
    >
      <a href="#!" className="datatable-sorter" onClick={(e) => e.preventDefault()}>
        {label}
      </a>
    </th>
  )
}

export default SortableTh
